import angular = require("angular");

import {ModelBase, BaseModel, modelModule } from "./model";
import IAdHocNode = model.IAdHocNode;
import IAdHocTree = model.IAdHocTree;
import * as _ from "lodash";

export class UIConfigModel extends ModelBase {
	constructor($http: ng.IHttpService, $q: ng.IQService, $log: ng.ILogService, baseModel: BaseModel) {
		super("api/UIConfig/", $http, $q, $log, baseModel);
	}

    public getAsset360Logo() {
        var deferred: ng.IDeferred<string> = this.$q.defer();

        this.$http.get<string>(this.GetUrl("Asset360Logo"),
            { 'params': { } })
            .then((mydata) => {
                let data = mydata.data.replace(/"/g, "");
                deferred.resolve(data);
            })
            .catch((err) => {
                this.LogError("getAsset360Logo", err);
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

	public getWidgetConfig(appName: string, widgetName: string) {
		var deferred: ng.IDeferred<string> = this.$q.defer();

		this.$http.get<string>(this.GetUrl("GetWidgetConfig"),
			{ 'params': { 'appName': appName, 'widgetID': widgetName } })
            .then((data) => {
				deferred.resolve(data.data);
            })
            .catch((err) => {
				this.LogError("getWidgetConfig",err);
				deferred.reject(err.data);
            });

		return deferred.promise;
	};

	public getAppContext(id: number | string) {
		var deferred: angular.IDeferred<model.IAppContext> = this.$q.defer();

		this.$http.get<model.IAppContext>(this.GetUrl("AppContext"), {
			'params': {
				'id': id
			}
		})
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getAppContext", data);
			});

		return deferred.promise; 
	}

	private appContextCache: { [id: number]: boolean } = {};
	public hasAccessToAppContext (appContextId:number) {
		var deferred:ng.IDeferred<boolean> = this.$q.defer();

		if (angular.isDefined(this.appContextCache[appContextId])) {
			deferred.resolve(this.appContextCache[appContextId]);
		}
		else {
			this.$http.get<boolean>(this.GetUrl("AppContextAllowed"), {
				'params': {
					'appContextId': appContextId
				}
			})
				.then((data) => {
					this.appContextCache[appContextId] = data.data;
					deferred.resolve(data.data);
				})
				.catch((data) => {
					this.LogError("hasAccessToAppContext",data);
					deferred.reject(data.data);
				});
		}
		return deferred.promise;
	}

	public getAssetKpi(assetID: number, startTime: Date, endTime: Date, operation: string= "All") {
		var deferred: ng.IDeferred<model.IKpiData[]> = this.$q.defer();

		var url = 'api/ProcessData/Kpi';
		this.$http.get<model.IKpiData[]>(this.baseModel.getUrl(url), {
			'params': {
				'assetId': assetID,
				'startTime': this.toDateTime(startTime),
				'endTime': this.toDateTime( endTime),
				'operationAsString': operation
			}
		})
			.then( (data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("getAssetKpi",data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	}



	public getOptionsExplorerConfigs(appContextID: number, assetID: number, analysisSetID: number, optionsExplorerConfigID: number = -1) {
		var deferred: ng.IDeferred<model.IOptionsExplorerConfig[]> = this.$q.defer();

		if (_.isNil(assetID) || _.isNil(appContextID)) {
			deferred.resolve([]);
		}
		else {
			this.$http.get<model.IOptionsExplorerConfig[]>(this.GetUrl("GetOptionsExplorerConfigs"), {
				'params': {
					'appContextID': appContextID,
					'assetID': assetID,
					'furtherID': analysisSetID,
					'OptionsExplorerConfigID': optionsExplorerConfigID
				}
			})
				.then((data) => {
					for (var d of data.data) {
						d.Config = angular.fromJson(d.JSONConfigString);
						d.Config.Dirty = false; //just loaded the thing, it can't be dirty yet.
						d.Config.Id = d.OptionsExplorerConfigID;
						if (!angular.isDefined(d.Config.Name)) d.Config.Name = d.Config.Display;//for compatability with configs from before the Name field existed.
					}
					deferred.resolve(data.data);
				})
				.catch((data) => {
					this.LogError("getOptionsExplorerConfigs", data);
					deferred.reject(data.data);
				});
		}
		return deferred.promise;
	}

	public saveOptionsExplorerConfig(config: any, appContextID: number, assetID: number, analysisSetID: number, optionsExplorerConfigID?: number, isPublic?: boolean) {
		var deferred: ng.IDeferred<model.IOptionsExplorerConfig> = this.$q.defer();


		if (!angular.isDefined(optionsExplorerConfigID)) {
			if (angular.isDefined(config.Id) && config.Id > 0) {
				optionsExplorerConfigID = config.Id;
			}
			else {
				optionsExplorerConfigID = -1;
			}
		}
		if (!angular.isDefined(isPublic)) {
			if (angular.isDefined(config.IsPublic)) {
				isPublic = config.IsPublic;
			}
			else {
				isPublic = false;
			}
		}
		//Since we're saving the config, we need to set the Dirty flag false. But it should only
		//really get set False when the save succeeds. At the same time, though, we don't want to
		//save it with the Dirty flag set True. So: set it False, serialize, then set it back to 
		//its original value.
		var originalDirtyFlag = config.Dirty;
		config.Dirty = false;
		var configAsString = angular.toJson(config);
		config.Dirty = originalDirtyFlag;

		this.$http.post<model.IOptionsExplorerConfig>(this.GetUrl("SaveOptionsExplorerConfig"), {
			OptionsExplorerConfigID: optionsExplorerConfigID,
			AppContextID: appContextID,
			AssetID: assetID,
			FurtherID: analysisSetID,
			JSONConfigString: configAsString,
			IsPublic: isPublic
		})
			.then((data) => {
				data.data.Config = angular.fromJson(data.data.JSONConfigString);
				data.data.Config.Id = data.data.OptionsExplorerConfigID;
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError("saveOptionsExplorerConfig",data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	};

	public getRiskMatrixUserConfigs(appContextID: number, assetID: number) {
		var deferred: angular.IDeferred<model.IRiskMatrixUserConfig[]> = this.$q.defer();

		if (_.isNil(assetID) || _.isNil(appContextID)) {
			deferred.resolve([]);
		}
		else {
			this.$http.get<model.IRiskMatrixUserConfig[]>(this.GetUrl('RiskMatrixUserConfigs'), {
				'params': {
					'appContextID': appContextID,
					'assetID': assetID
				}
			})
				.then((data) => {
					deferred.resolve(data.data);
				})
				.catch((data) => {
					this.LogError('getRiskMatrixUserConfigs', data);
					deferred.reject(data.data);
				});
		}
		return deferred.promise;
	}

	public saveRiskMatrixUserConfig(config: any) {
		var deferred: angular.IDeferred<model.IRiskMatrixUserConfig> = this.$q.defer();

		this.$http.put<model.IRiskMatrixUserConfig>(this.GetUrl('RiskMatrixUserConfig'), config)
			.then((data) => {
				deferred.resolve(data.data);
			})
			.catch((data) => {
				this.LogError('saveRiskMatrixUserConfig', data);
				deferred.reject(data.data);
			});

		return deferred.promise;
	};

    public getAdHocTrees(appContextId: number | string) {
        var deferred: ng.IDeferred<model.IAdHocTree[]> = this.$q.defer();

        var url = 'GetAdHocTrees';
        this.$http.get<model.IAdHocTree[]>(this.GetUrl(url), {
            'params': {
                'appContextId': appContextId
            }
        }).then( (data) => {
                deferred.resolve(data.data);
		}).catch((data) => {
                this.LogError("getAdHocTrees",data);
                deferred.reject(data.data);
		});

        return deferred.promise;
    }

    public isPhysicalTree(treeGuid: string) {
        var deferred: ng.IDeferred<boolean> = this.$q.defer();

        var url = 'PhysicalTree';
        this.$http.get<boolean>(this.GetUrl(url), {
            'params': {
                'treeGuid': treeGuid
            }
        }).then( (data) => {
                deferred.resolve(data.data);
		}).catch((err) => {
                this.LogError("isPhysicalTree",err.data);
                deferred.reject(err.data);
		});

        return deferred.promise;
    }

    public getChildrenUsingNode(node: IAdHocNode, includeSensors?: boolean, includeAllEntities?: boolean) {

        var deferred: ng.IDeferred<model.IAdHocNode[]> = this.$q.defer();
        this.$http.post<model.IAdHocNode[]>(this.GetUrl('GetChildren'), node, {
            'params':{
                'includeSensors': (includeSensors == true),
                'includeAllEntities': (includeAllEntities == true)
            }
        })
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("getChildrenUsingNode", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public saveAdHocNode(node: IAdHocNode) {

        var deferred: ng.IDeferred<model.IAdHocNode> = this.$q.defer();
        this.$http.post<model.IAdHocNode>(this.GetUrl('SaveAdHocNode'), node)
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("saveAdHocNode", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public deleteAdHocNode(nodeGuid: string) {
        var deferred: ng.IDeferred<void> = this.$q.defer<void>();

        var url = 'DeleteAdHocNode';
        this.$http.get<void>(this.GetUrl(url), {
            'params': {
                'nodeGuid': nodeGuid
            }
        }).then( () => {
            deferred.resolve();
        }).catch((data) => {
            this.LogError("deleteAdHocNode", data);
            deferred.reject(data.data);
        });

        return deferred.promise;
    }

    public saveAdHocTree(tree: IAdHocTree) {

        var deferred: ng.IDeferred<model.IAdHocTree> = this.$q.defer();
        this.$http.post<model.IAdHocTree>(this.GetUrl('SaveAdHocTree'), tree)
            .then((data) => {
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("saveAdHocTree", data);
                deferred.reject(data.data);
            });
        return deferred.promise;
    }

    public deleteAdHocTree(treeGuid: string) {
        var deferred: ng.IDeferred<void> = this.$q.defer<void>();

        var url = 'DeleteAdHocTree';
        this.$http.get<void>(this.GetUrl(url), {
            'params': {
                'treeGuid': treeGuid
            }
        }).then( () => {
            deferred.resolve();
        }).catch((data) => {
            this.LogError("deleteAdHocTree", data);
            deferred.reject(data.data);
        });

        return deferred.promise;
    }

	//THis method will get the nodes necessary to initially display a tree.  It includes
	//all of the adhoc tree nodes the user has access to as well as the first nodes the user has access to 
	//if they don't have access to the non-derived node.  For instance, if a user doesn't have access to a client
	//but does have access to the station under the client, this method will return the station node derived from the
	//client node, but not the client node.  
    public getInitialNodes(treeGuid: string, includeSensors?: boolean) {
        var deferred: ng.IDeferred<model.IAdHocNode[]> = this.$q.defer();

		var url = 'GetInitialNodes';
        this.$http.get<model.IAdHocNode[]>(this.GetUrl(url), {
            'params': {
                'treeGuid': treeGuid,
                'includeSensors':(includeSensors == true)
            }
        }).then( (data) => {
            deferred.resolve(data.data);
        }).catch((data) => {
            this.LogError("getInitialNodes",data);
            deferred.reject(data.data);
        });

        return deferred.promise;
    }

    public getAdHocUiConfigurationOptions() {
        var deferred: ng.IDeferred<model.IAdHocUiConfigurationOptions> = this.$q.defer();

        var url = 'GetAdHocUiConfigurationOptions';
        this.$http.get<model.IAdHocUiConfigurationOptions>(this.GetUrl(url), {
            'params': {
             }
        }).then( (data) => {
            deferred.resolve(data.data);
        }).catch((data) => {
            this.LogError("getAdHocUiConfigurationOptions",data);
            deferred.reject(data.data);
        });

        return deferred.promise;
    }

    public swapNodeDisplayOrders(nodeA: IAdHocNode, nodeB: IAdHocNode) {
        var deferred: ng.IDeferred<boolean> = this.$q.defer();

        var url = 'SwapNodeDisplayOrders';
        this.$http.get<boolean>(this.GetUrl(url), {
            'params': {
                'node1Guid': nodeA.NodeId,
                'node2Guid': nodeB.NodeId,
            }
        }).then( (data) => {
            deferred.resolve(data.data);
        }).catch((data) => {
            this.LogError("swapNodeDisplayOrders",data);
            deferred.reject(data.data);
        });

        return deferred.promise;
    }

    public getAllTreesForUser() {
        var deferred: ng.IDeferred<model.IAdHocTree[]> = this.$q.defer();

        var url = 'GetAllTreesForUser';
        this.$http.get<model.IAdHocTree[]>(this.GetUrl(url), {
            'params': {
            }
        }).then( (data) => {
            deferred.resolve(data.data);
        }).catch((data) => {
            this.LogError("getAllTreesForUser",data);
            deferred.reject(data.data);
        });

        return deferred.promise;
    }

    public getAllTreeNodes(treeGuid: string) {
        var deferred: ng.IDeferred<model.IAdHocNode[]> = this.$q.defer();

        var url = 'GetAllTreeNodes';
        this.$http.get<model.IAdHocNode[]>(this.GetUrl(url), {
			'params': {
				'treeGuid': treeGuid
            }
        }).then( (data) => {
            deferred.resolve(data.data);
        }).catch((data) => {
            this.LogError("getAllTreeNodes",data);
            deferred.reject(data.data);
        });

        return deferred.promise;
    }

    public getAdHocTreePermissions() {
        var deferred: ng.IDeferred<model.IAdHocTreePermissions> = this.$q.defer();

        var url = 'GetAdHocTreePermissions';
        this.$http.get<model.IAdHocTreePermissions>(this.GetUrl(url), {
            'params': {
            }
        }).then( (data) => {
            deferred.resolve(data.data);
        }).catch((data) => {
            this.LogError("getAdHocTreePermissions",data);
            deferred.reject(data.data);
        });

        return deferred.promise;
	}

    public LoadNodeFromKey(treeID: string, parentID: string, nodeID: string, assetID: string, appContextID: string, includeAllEntities?: boolean, getAssetTrees?:boolean) {
		var deferred: ng.IDeferred<{ trees: model.IAdHocTree[], nodes: model.IAdHocNode[] }> = this.$q.defer();

		
		this.$http.get<any>(this.GetUrl('LoadNodeFromKey'), {
			'params': {
				'treeID': treeID,
				'parentID': parentID,
				'nodeID': nodeID,
				'assetID': assetID,
                'appContextID': appContextID,
                'includeAllEntities': includeAllEntities,
                'getAssetTrees': angular.isDefined(getAssetTrees) ? getAssetTrees : true
			}
		}).then((data) => {
			deferred.resolve({ trees: data.data.m_Item1, nodes: data.data.m_Item2 });

		}).catch((data) => {
			this.LogError("LoadNodeFromKey", data);
			deferred.reject(data.data);
		});

		return deferred.promise;
	}

    public GetKeyForAssetOnDefaultTree(assetID: number) {
        var deferred: ng.IDeferred<string> = this.$q.defer();

        this.$http.get<string>(this.GetUrl("KeyForAssetOnDefaultTree"),
            { 'params': { 'assetID': assetID } })
            .then((mydata) => {                
                deferred.resolve(mydata.data);
            })
            .catch((err) => {
                this.LogError("getKeyForAssetOnDefaultTree", err);
                deferred.reject(err.data);
            });

        return deferred.promise;
    };

    public getTimeRangeCriteriaList() {

        var deferred: ng.IDeferred<model.ICriteria[]> = this.$q.defer();
        //if (this.baseModel.storage[this.s]) {
        //    deferred.resolve(JSON.parse(this.baseModel.storage[this.summaryTypesKey]));
        //}
        //else {
        this.$http.get<model.ICriteria[]>(this.GetUrl("TimeSelectorCriteria"))
                .then((data) => {
                    //this.baseModel.storage[this.summaryTypesKey] = JSON.stringify(data.data);
                    deferred.resolve(data.data);
                })
                .catch((data) => {
                    this.LogError("TimeSelectorCriteria", data);
                    deferred.reject(data.data);
                });
        //}

        return deferred.promise;
    }

    public getTimeRangeCriteriaListDB() {

        var deferred: ng.IDeferred<model.ICriteria[]> = this.$q.defer();
        //if (this.baseModel.storage[this.s]) {
        //    deferred.resolve(JSON.parse(this.baseModel.storage[this.summaryTypesKey]));
        //}
        //else {
        this.$http.get<model.ICriteria[]>(this.GetUrl("TimeSelectorListCriteria"))
            .then((data) => {
                //this.baseModel.storage[this.summaryTypesKey] = JSON.stringify(data.data);
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("TimeSelectorListCriteria", data);
                deferred.reject(data.data);
            });
        //}

        return deferred.promise;
    }

    public getCriteriaObjectListCategory(categoryID: number, appContextID: number = null, tabID: number = null) {

        var deferred: ng.IDeferred<model.ICriteria[]> = this.$q.defer();
        //if (this.baseModel.storage[this.s]) {
        //    deferred.resolve(JSON.parse(this.baseModel.storage[this.summaryTypesKey]));
        //}
        //else {
        this.$http.get<model.ICriteria[]>(this.GetUrl("TimeSelectorCategoryCriteria"),
            {
                'params': {
                    'categoryID': categoryID,
                    'appContextID': appContextID,
                    'tabID': tabID
                }
            })
            .then((data) => {
                //this.baseModel.storage[this.summaryTypesKey] = JSON.stringify(data.data);
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("TimeSelectorCategoryCriteria", data);
                deferred.reject(data.data);
            });
        //}

        return deferred.promise;
    };

    public getTimeRangeDateRangeFromCriteria(criteriaFilterid : number, startDate: Date, endDate: Date) {
        //"TimeSelectorGetDateRangeFromCriteria"

        var deferred: ng.IDeferred<model.IDateRange> = this.$q.defer();
        //if (this.baseModel.storage[this.s]) {
        //    deferred.resolve(JSON.parse(this.baseModel.storage[this.summaryTypesKey]));
        //}
        //else {
        this.$http.get<model.IDateRange>(this.GetUrl("TimeSelectorGetDateRangeFromCriteria"), { 'params': { 'criteriaFilterid': criteriaFilterid, 'startDate': startDate, 'endDate': endDate } })
            .then((data) => {
                //this.baseModel.storage[this.summaryTypesKey] = JSON.stringify(data.data);
                deferred.resolve(data.data);
            })
            .catch((data) => {
                this.LogError("TimeSelectorGetDateRangeFromCriteria", data);
                deferred.reject(data.data);
            });
        //}

        return deferred.promise;
    }


}

modelModule.factory('uiconfigModel', ['$http', '$q', '$log', 'baseModel', ($http, $q, $log, baseModel) => new UIConfigModel($http, $q, $log, baseModel)]);


// WEBPACK FOOTER //
// ./Common/Models/UIConfigModel.ts